(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[600],{

/***/ 4848:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility/city/[slug]",
      function () {
        return __webpack_require__(5721);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1817);
/* harmony import */ var _app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7213);
/* harmony import */ var _app_layouts_partials_RegionDetail__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2210);






var Index = function(param) {
    var params = param.params;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), mode = ref2[0], setMode = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // window.analytics.page("viewed");
        if (window.innerWidth < 768) {
            setMode("mobile");
        } else {
            setMode("desktop");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_component_commons_meta_Meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Find Storage Unit Auctions Happening Near Me in ".concat(params.city.name, ", ").concat((ref = params.city.state) === null || ref === void 0 ? void 0 : ref.name, " | StorageUnitAuctionList.com"),
                description: "Find Storage Unit Auctions happening in ".concat(params.city.name, ", ").concat((ref1 = params.city.state) === null || ref1 === void 0 ? void 0 : ref1.name, " and every major city in the United States. Signup in minutes to get access to the most up to date list of storage unit auctions happening near you.")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container mx-auto ",
                    children: mode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_layouts_partials_RegionDetail__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        data: params,
                        type: "city",
                        mode: mode
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [255,939,477,659,641,774,888,179], function() { return __webpack_exec__(4848); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);